import { Button } from '@lmig/lmds-react-button';
import { useUserData } from 'Foundation/User/UserContext';
import { useEffect, useState } from 'react';
import { ClearA360Session, ClearSession, ServerInfo } from './Helpers/AdminApi';

export function SiteTools() {
  const { userData } = useUserData();
  const [a360ClearStatus, setA360ClearStatus] = useState<boolean | undefined>(undefined);
  const [clearServerSessionStatus, setClearServerSessionStatus] = useState<boolean | undefined>(undefined);
  const [serverName, setServerName] = useState('');
  useEffect(() => {
    async function GetServerInformation() {
      let serverInfo = await ServerInfo();
      if (serverInfo) setServerName(serverInfo.serverName);
    }
    GetServerInformation();
  }, []);
  async function onClearA360Cache() {
    const status = await ClearA360Session();
    setA360ClearStatus(status);
  }
  async function onClearSession() {
    const status = await ClearSession();
    setClearServerSessionStatus(status);
  }

  return (
    <>
      {!userData?.isAgent() && (
        <div>
          <div className="container">
            <div className="row">
              <span style={{ fontWeight: 700 }}>Server Instance: {serverName}</span>
            </div>
            <div className="row" style={{ marginTop: '15px' }}>
              <Button
                size="large"
                variant="primary"
                onClick={onClearA360Cache}
                className="btnSubmit"
                style={{ width: '250px' }}
              >
                Clear A360 Cache
              </Button>
              {a360ClearStatus !== undefined && (
                <>
                  {a360ClearStatus ? (
                    <div className="alert alert-success" role="alert" style={{ marginLeft: '15px' }}>
                      A360 cache clear successful
                    </div>
                  ) : (
                    <div className="alert alert-danger" role="alert" style={{ marginLeft: '15px' }}>
                      A360 cache clear failed
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="row" style={{ marginTop: '15px' }}>
              <Button
                size="large"
                variant="primary"
                onClick={onClearSession}
                className="btnSubmit"
                style={{ width: '250px' }}
              >
                Clear Server Session
              </Button>
              {clearServerSessionStatus !== undefined && (
                <>
                  {clearServerSessionStatus ? (
                    <div className="alert alert-success" role="alert" style={{ marginLeft: '15px' }}>
                      Server session cache clear successful
                    </div>
                  ) : (
                    <div className="alert alert-danger" role="alert" style={{ marginLeft: '15px' }}>
                      Server session cache clear failed
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
